<p>
  registration-configuration works!
</p>
